import { creditLine } from "./reducer";

export function getCreditLineModule() {
  return {
    // Unique id of the module
    id: "CreditLine",
    // Maps the Store key to the reducer
    reducerMap: {
      creditLine
    }
  };
}
